import styledBase from 'styled-components';

export const base = {
  Image: styledBase.img,
  Text: styledBase.span,
  View: styledBase.div,
};

export const styledWrapper = styledBase as typeof styledBase;
